import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import logo from '../assets/logo-sf.png';
import "./Sidebar.css";

const Sidebar = () => {
  const { logout } = useContext(AuthContext);

  return (
    <div className="sidebar">
      <img src={logo} alt="Logo" className="logo" />
      <div className="menu">
        <NavLink to="/" end className={({ isActive }) => isActive ? "active" : ""}>
          Serviços
        </NavLink>
        <NavLink to="/Meus_servicos" className={({ isActive }) => isActive ? "active" : ""}>
          Anunciar
        </NavLink>
        <NavLink to="/Pagamentos" className={({ isActive }) => isActive ? "active" : ""}>
          Pagamentos
        </NavLink>
        <NavLink to="/Perfil" className={({ isActive }) => isActive ? "active" : ""}>
          Perfil
        </NavLink>
        <button className="logout-button" onClick={logout}>
          Sair
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
